import styled from 'styled-components';

export const Container = styled.div`
  background: #ddd;
  border-radius: 5px;
  overflow-y: auto;
  max-height: 250px;
  width: 100%;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #bbb;
  }
`;
